<template>
    <div class="dashboard_main" :class="{'cn':version==1}">
        <div class="dashboard_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="dashboard_right">
            <div class="dashboard_right_box1">
                <div class="right_top_box1">
                    <div class="right_top_box1_b">
                        <p class="title">
                            <template v-if="domainName != 'plant'">
                                <template v-if="hotelType==0">{{$t('App.dashboard.text1')}}</template>
                                <template v-if="hotelType==1">{{$t('App.dashboard.text53')}}</template>
                            </template>
                            
                            <template v-if="domainName == 'plant'">{{$t('App.dashboard.text58')}}</template>
                        </p>
                        <div class="div">
                            <p class="p">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text2')}}：</span></span><span class="span2">{{homeData.roomCount}}</span>
                            </p>

                            <p class="p" v-if="hotelType==1">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text54')}}：</span></span><span class="span2">{{homeData.classroomLightOnlineCount}}<i> / </i>{{homeData.classroomLightCount}}</span>
                            </p>
                            <p class="p" v-if="hotelType==1">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text55')}}：</span></span><span class="span2">{{homeData.blackboardLightOnlineCount}}<i> / </i>{{homeData.blackboardLightCount}}</span>
                            </p>
                            <p class="p" v-if="hotelType==1">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text56')}}：</span></span><span class="span2">{{homeData.panelDeviceOnlineCount}}<i> / </i>{{homeData.panelDeviceCount}}</span>
                            </p>
                            <p class="p" v-if="hotelType==1">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text57')}}：</span></span><span class="span2">{{homeData.curtainDeviceOnlineCount}}<i> / </i>{{homeData.curtainDeviceCount}}</span>
                            </p>

                            <p class="p">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text5')}}：</span></span><span class="span2">{{homeData.lightOnlineCount}}<i> / </i>{{homeData.lightCount}}</span>
                            </p>
                            <p class="p">
                                <span class="span1">
                                    <i class="i"></i>
                                    <span>{{$t('App.dashboard.text6_1')}}</span>
                                    <span class="remarks">{{$t('App.dashboard.text6_2')}}：</span>
                                </span>
                                <span class="span2">{{homeData.cicLightOnlineCount}}<i> / </i>{{homeData.cicLightCount}}</span>
                            </p>
                            <p class="p">
                                <span class="span1">
                                    <i class="i"></i>
                                    <span>{{$t('App.dashboard.text4_1')}}</span>
                                    <span class="remarks">{{$t('App.dashboard.text4_2')}}</span>
                                    <span>{{$t('App.dashboard.text4_3')}}：</span>
                                </span>
                                <span class="span2">{{homeData.sensorOnlineCount}}<i> / </i>{{homeData.sensorCount}}</span>
                            </p>
                            <p class="p">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text3')}}：</span></span><span class="span2">{{homeData.airPurOnlineCount}}<i> / </i>{{homeData.airPurCount}}</span>
                            </p>
                            <p class="p">
                                <span class="span1"><i class="i"></i><span>{{$t('App.dashboard.text7')}}：</span></span><span class="span2">{{homeData.netOnlineCount}}<i> / </i>{{homeData.netCount}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dashboard_right_box2">
                <div class="right_top_box2">
                    <div class="top-box">
                        <div class="left">
                            <span class="span1">{{$t('App.dashboard.text40')}}</span>
                            <span class="span2">{{$t('App.dashboard.text41')}}</span>
                            <span class="span1">{{$t('App.dashboard.text42')}}</span>
                            <span class="span2">({{echartsTimeText}})</span>
                        </div>
                        <div class="right">
                            <div class="btn" :class="{'select':echartsLType == '0'}" @click="echartsLTypeFun('0')">{{$t('App.dashboard.text43')}}</div>
                            <div class="btn" :class="{'select':echartsLType == '1'}" @click="echartsLTypeFun('1')">{{$t('App.dashboard.text44')}}</div>
                            <div class="btn" :class="{'select':echartsLType == '2'}" @click="echartsLTypeFun('2')">{{$t('App.dashboard.text45')}}</div>
                            <div class="tis-btn">
                                <div class="hover-div"></div>
                                <div class="tis-box">
                                    <p class="tis-title">{{$t('App.dashboard.text46')}}</p>
                                    <div class="tis-ul">
                                        <div class="tis-li">
                                            <div class="tis-item">{{$t('App.dashboard.text47')}}</div>
                                            <div class="tis-item">PM2.5</div>
                                            <div class="tis-item">PM10</div>
                                            <div class="tis-item">CO₂</div>
                                            <div class="tis-item">TVOC</div>
                                            <div class="tis-item">{{$t('App.dashboard.text13')}}</div>
                                        </div>
                                        <div class="tis-li">
                                            <div class="tis-item">{{$t('App.dashboard.text48')}}</div>
                                            <div class="tis-item">µg/m³</div>
                                            <div class="tis-item">µg/m³</div>
                                            <div class="tis-item">ppm</div>
                                            <div class="tis-item">ppb</div>
                                            <div class="tis-item">ppb</div>
                                        </div>
                                        <div class="tis-li">
                                            <div class="tis-item">{{classificationArr2[0]}}</div>
                                            <div class="tis-item">&lt;15</div>
                                            <div class="tis-item">&lt;20</div>
                                            <div class="tis-item">&lt;800</div>
                                            <div class="tis-item">&lt;200</div>
                                            <div class="tis-item">&lt;30</div>
                                        </div>
                                        <div class="tis-li">
                                            <div class="tis-item">{{classificationArr2[1]}}</div>
                                            <div class="tis-item">{{'15-30'}}</div>
                                            <div class="tis-item">{{'20-100'}}</div>
                                            <div class="tis-item">{{'800-1000'}}</div>
                                            <div class="tis-item">{{'200-600'}}</div>
                                            <div class="tis-item">{{'30-100'}}</div>
                                        </div>
                                        <div class="tis-li">
                                            <div class="tis-item">{{classificationArr2[2]}}</div>
                                            <div class="tis-item">{{'>30'}}</div>
                                            <div class="tis-item">{{'>100'}}</div>
                                            <div class="tis-item">{{'>1000'}}</div>
                                            <div class="tis-item">{{'>600'}}</div>
                                            <div class="tis-item">{{'>100'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ul">
                        <div class="li">
                            <div class="div1"><span class="text1">PM2.5</span></div>
                            <div class="div2"><span class="text2">{{roomEnvStatusData.PM25_current}}</span><span class="text3">µg/m³</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.PM25_current_level]}">{{classificationArr2[roomEnvStatusData.PM25_current_level]}}</span></div>
                            <div class="div3"><span class="text2">{{roomEnvStatusData.PM25_avg}}</span><span class="text3">µg/m³</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.PM25_avg_level]}">{{classificationArr2[roomEnvStatusData.PM25_avg_level]}}</span></div>
                            <div class="echarts echarts-PM25"></div>
                            <span class="echarts-minTime">{{echartsMinTime}}</span>
                            <span class="echarts-maxTime">{{echartsMaxTime}}</span>
                        </div>
                        <div class="li">
                            <div class="div1"><span class="text1">PM10</span></div>
                            <div class="div2" v-if="roomEnvStatusData.PM10_current!=0"><span class="text2">{{roomEnvStatusData.PM10_current}}</span><span class="text3">µg/m³</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.PM10_current_level]}">{{classificationArr2[roomEnvStatusData.PM10_current_level]}}</span></div>
                            <div class="div2" v-if="roomEnvStatusData.PM10_current==0"><span class="text2">-</span></div>

                            <div class="div3" v-if="roomEnvStatusData.PM10_avg!=0"><span class="text2">{{roomEnvStatusData.PM10_avg}}</span><span class="text3">µg/m³</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.PM10_avg_level]}">{{classificationArr2[roomEnvStatusData.PM10_avg_level]}}</span></div>
                            <div class="div3" v-if="roomEnvStatusData.PM10_avg==0"><span class="text2">-</span></div>

                            <div class="echarts echarts-PM10"></div>
                            <span class="echarts-minTime">{{echartsMinTime}}</span>
                            <span class="echarts-maxTime">{{echartsMaxTime}}</span>
                        </div>
                        <div class="li">
                            <div class="div1"><span class="text1">CO₂</span></div>
                            <div class="div2"><span class="text2">{{roomEnvStatusData.CO2_current}}</span><span class="text3">ppm</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.CO2_current_level]}">{{classificationArr2[roomEnvStatusData.CO2_current_level]}}</span></div>
                            <div class="div3"><span class="text2">{{roomEnvStatusData.CO2_avg}}</span><span class="text3">ppm</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.CO2_avg_level]}">{{classificationArr2[roomEnvStatusData.CO2_avg_level]}}</span></div>
                            <div class="echarts echarts-CO2"></div>
                            <span class="echarts-minTime">{{echartsMinTime}}</span>
                            <span class="echarts-maxTime">{{echartsMaxTime}}</span>
                        </div>
                        <div class="li">
                            <div class="div1"><span class="text1">TVOC</span></div>
                            <div class="div2"><span class="text2">{{roomEnvStatusData.TVOC_current}}</span><span class="text3">ppb</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.TVOC_current_level]}">{{classificationArr2[roomEnvStatusData.TVOC_current_level]}}</span></div>
                            <div class="div3"><span class="text2">{{roomEnvStatusData.TVOC_avg}}</span><span class="text3">ppb</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.TVOC_avg_level]}">{{classificationArr2[roomEnvStatusData.TVOC_avg_level]}}</span></div>
                            <div class="echarts echarts-TVOC"></div>
                            <span class="echarts-minTime">{{echartsMinTime}}</span>
                            <span class="echarts-maxTime">{{echartsMaxTime}}</span>
                        </div>
                        <div class="li">
                            <div class="div1"><span class="text1">{{$t('App.dashboard.text13')}}</span></div>
                            <div class="div2"><span class="text2">{{roomEnvStatusData.HCHO_current}}</span><span class="text3">ppb</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.HCHO_current_level]}">{{classificationArr2[roomEnvStatusData.HCHO_current_level]}}</span></div>
                            <div class="div3"><span class="text2">{{roomEnvStatusData.HCHO_avg}}</span><span class="text3">ppb</span><span class="text4" :style="{'color':classificationColorArr2[roomEnvStatusData.HCHO_avg_level]}">{{classificationArr2[roomEnvStatusData.HCHO_avg_level]}}</span></div>
                            <div class="echarts echarts-HCHO"></div>
                            <span class="echarts-minTime">{{echartsMinTime}}</span>
                            <span class="echarts-maxTime">{{echartsMaxTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="right_data_left">
                    <div class="box1"></div>
                    <div class="map" id="map"></div>
                </div>
            </div>
            <div class="dashboard_right_box3">
                <div class="right_top_box3">
                    <div class="p1">
                        <div>
                            <span class="span1">{{hotelWeather.location}}</span>
                        </div>
                        <div class="p1-right">
                            <div class="img_box" v-if="hotelWeather.cond_code">
                                <img :src="'./img/weather/'+hotelWeather.cond_code+'.png'">
                            </div>
                            <span class="span2">{{hotelWeather.cond_txt}}</span>
                        </div>
                    </div>
                    <div class="flex_box">
                        <div class="box1">
                            <p class="model">{{hotelWeather.aqi}}</p>
                            <p class="label">{{$t('App.dashboard.text49')}}</p>
                        </div>
                        <div class="box2">
                            <p class="model">{{hotelWeather.pm25}}</p>
                            <p class="label">PM2.5</p>
                        </div>
                        <div class="box3">
                            <p class="model">{{hotelWeather.pm10}}</p>
                            <p class="label">PM10</p>
                        </div>
                    </div>
                    <div class="flex_box_classification">
                        <div class="box1" :style="{'color':classificationColorArr2[hotelWeather.aqi_level]}">
                            {{classificationArr2[hotelWeather.aqi_level]}}
                        </div>
                        <div class="box2" :style="{'color':classificationColorArr2[hotelWeather.pm25_level]}">
                            {{classificationArr2[hotelWeather.pm25_level]}}
                        </div>
                        <div class="box3" :style="{'color':classificationColorArr2[hotelWeather.pm10_level]}">
                            {{classificationArr2[hotelWeather.pm10_level]}}
                        </div>
                    </div>
                    <div class="flex_box3">
                        <div class="div1">
                            <p class="p1">{{$t('App.dashboard.text11')}}</p>
                            <p class="p2">{{hotelWeather.tmp?hotelWeather.tmp:0}}℃</p>
                            <p class="p1">{{$t('App.dashboard.text15')}}</p>
                            <p class="p2">{{hotelWeather.wind_spd?hotelWeather.wind_spd:0}}km/h</p>
                        </div>
                        <div class="div2">
                            <p class="p1">{{$t('App.dashboard.text12')}}</p>
                            <p class="p2">{{hotelWeather.hum?hotelWeather.hum:0}}RH%</p>
                            <p class="p1">{{$t('App.dashboard.text16')}}</p>
                            <p class="p2">{{hotelWeather.pcpn?hotelWeather.pcpn:0}}mm</p>
                        </div>
                        <div class="div3">
                            <p class="p1">{{$t('App.dashboard.text17')}}</p>
                            <p class="p2">{{hotelWeather.pres?hotelWeather.pres:0}}Pa</p>
                            <p class="p1">{{$t('App.dashboard.text18')}}</p>
                            <p class="p2">{{hotelWeather.vis?hotelWeather.vis:0}}km</p>
                        </div>
                    </div>
                 <!--    <p class="title">{{$t('App.dashboard.text14')}}</p>
                    <div class="flex_box1">
                        <div class="div1">
                            <span :style="{'font-size':Number(hotelWeather.averageAir)?'':'2rem','margin-right':Number(hotelWeather.averageAir)?'':'1rem'}">{{hotelWeather.averageAir}}</span>
                        </div>
                        <div class="div2">
                            <p class="p2">{{hotelWeather.location}}</p>
                            <p class="p1">{{hotelWeather.airStatus}}</p>
                        </div>
                    </div>
                    <div class="flex_box2">
                        <div class="img_box" v-if="hotelWeather.cond_code">
                            <img :src="'./img/weather/'+hotelWeather.cond_code+'.png'">
                        </div>
                        <div class="text_box">
                            {{hotelWeather.cond_txt}}
                        </div>
                    </div>
                    <div class="flex_box3">
                        <div class="div1">
                            <p class="p1">{{$t('App.dashboard.text11')}}</p>
                            <p class="p2">{{hotelWeather.tmp?hotelWeather.tmp:0}}℃</p>
                            <p class="p1">{{$t('App.dashboard.text15')}}</p>
                            <p class="p2">{{hotelWeather.wind_spd?hotelWeather.wind_spd:0}}km/h</p>
                        </div>
                        <div class="div2">
                            <p class="p1">{{$t('App.dashboard.text12')}}</p>
                            <p class="p2">{{hotelWeather.hum?hotelWeather.hum:0}}RH%</p>
                            <p class="p1">{{$t('App.dashboard.text16')}}</p>
                            <p class="p2">{{hotelWeather.pcpn?hotelWeather.pcpn:0}}mm</p>
                        </div>
                        <div class="div3">
                            <p class="p1">{{$t('App.dashboard.text17')}}</p>
                            <p class="p2">{{hotelWeather.pres?hotelWeather.pres:0}}Pa</p>
                            <p class="p1">{{$t('App.dashboard.text18')}}</p>
                            <p class="p2">{{hotelWeather.vis?hotelWeather.vis:0}}km</p>
                        </div>
                    </div> -->
                </div>
                <div class="right_data_right">
                    <p class="p1"><img src="../img/svg/repair_icon.svg"><span>{{$t('App.dashboard.text19')}}</span></p>
                    <div class="progress">
                        <svg viewBox="0 0 100 100">
                            <path d="
                                M 50 50 
                                m 0 -46 
                                a 46 46 0 1 1 0 92
                                a 46 46 0 1 1 0 -92"
                            stroke="rgba(255,255,255,0.3)" stroke-width="6" fill="none" style="stroke-dasharray: 300px, 300px; stroke-dashoffset: 0px;"></path>
                            <path d="
                                M 50 50 
                                m 0 -46 
                                a 46 46 0 1 1 0 92
                                a 46 46 0 1 1 0 -92"
                            stroke="rgba(255,255,255,0.9)" stroke-width="6" fill="none" stroke-linecap="round" :style="{'stroke-dasharray': '300px 300px','stroke-dashoffset': alarmInfo.alarmTotalCount==0?'600px':parseInt(alarmInfo.alarmAbnormality/alarmInfo.alarmTotalCount*600)+'px', 'transition': 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s'}" ></path>
                        </svg>
                        <p class="text1">{{alarmInfo.alarmTotalCount}}</p>
                        <p class="text2">{{$t('App.dashboard.text20')}}</p>
                    </div>
                    <div class="box1">
                        <div class="text1">
                            <i></i>
                            <span>{{$t('App.dashboard.text23')}}</span>
                        </div>
                        <div class="text2">{{alarmInfo.alarmFixed}}</div>
                    </div>
                    <!-- <div class="box2">
                        <div class="text1">
                            <i></i>
                            <span>{{$t('App.dashboard.text24')}}</span>
                        </div>
                        <div class="text2">{{alarmInfo.alarmAbnormality}}</div>
                    </div> -->
                    <div class="btn" @click="linkToFun('/service')">
                        <div>
                            <span class="span1">{{alarmInfo.alarmTimeout}}</span>
                            <span class="span2">{{$t('App.dashboard.text25')}}</span>
                        </div>
                        <div class="img_box">
                            →
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="full_screen" v-if="fullScreenShow">
            <div class="full_screen_map" id="full_screen_map"></div>
            <div class="sideBar_nav">
                <div class="title_box">
                    <div class="box1">
                        <div class="left">
                            <img :src="fullScreenMarker.devObj.avatar">
                        </div>
                        <div class="right">
                            <p class="p1">{{fullScreenMarker.devObj.name}}</p>
                            <p class="p2">{{fullScreenMarker.devObj.location}}</p>
                        </div>
                    </div>
                    <div class="box2">
                        <div class="li">
                            <span class="span1">{{$t('App.dashboard.text37')}}</span>
                            <span class="span2">{{fullScreenMarker.devObj.roomCount}}</span>
                        </div>
                        <div class="li">
                            <span class="span1">{{$t('App.dashboard.text38')}}</span>
                            <span class="span2">{{fullScreenMarker.devObj.aqi}}</span>
                        </div>
                    </div>
                    <div class="box3">
                        <div class="li">
                            <p class="p1">{{fullScreenMarker.devObj.airPurCount}}</p>
                            <p class="p2">{{$t('App.dashboard.text35')}}</p>
                        </div>
                        <div class="li">
                            <p class="p1">{{fullScreenMarker.devObj.sensorCount}}</p>
                            <p class="p2">{{$t('App.dashboard.text34')}}</p>
                        </div>
                        <div class="li">
                            <p class="p1">{{fullScreenMarker.devObj.lightCount}}</p>
                            <p class="p2">{{$t('App.dashboard.text32')}}</p>
                        </div>
                        <div class="li">
                            <p class="p1">{{fullScreenMarker.devObj.cicLightCount}}</p>
                            <p class="p2" v-if="domainName != 'plant'">{{$t('App.dashboard.text33')}}</p>
                            <p class="p2" v-if="domainName == 'plant'">{{$t('App.sideBar.text24')}}</p>
                        </div>
                    </div>
                </div>
                <div class="ul_box">
                    <div class="search">
                        <el-input :placeholder="$t('App.dashboard.text39')" v-model="keywords" @keyup.native="getHotelNavListKeyUp($event)" class="input-with-select">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="getHotelNavList()"></i>
                        </el-input>
                    </div>
                    <div class="ul scrollbar_style">
                        <div class="li" :class="{'select':hotelId == item.id}" v-for="item in hotelNavList" :key="item.id" @click="fullScreenMapClick(item)"  @mouseenter="fullScreenMouseOver($event,item)" @mouseleave="fullScreenMouseLeave($event,item)">
                            <div class="left">
                                <img :src="item.avatar"/>
                            </div>
                            <div class="right">
                                <p class="p1">{{item.name}}</p>
                                <p class="p2">{{item.location}}</p>
                                <i class="iconfont icon-qiehuan"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="title" :style="{'top':fullScreenTitleTop+'px'}" v-if="fullScreenTitleShow">
                <p class="p_title">{{fullScreenTitleData.name}}</p>
                <div class="box3">
                    <div class="li">
                        <p class="p1">{{fullScreenTitleData.airPurCount}}</p>
                        <p class="p2">{{$t('App.dashboard.text35')}}</p>
                    </div>
                    <div class="li">
                        <p class="p1">{{fullScreenTitleData.sensorCount}}</p>
                        <p class="p2">{{$t('App.dashboard.text34')}}</p>
                    </div>
                    <div class="li">
                        <p class="p1">{{fullScreenTitleData.lightCount}}</p>
                        <p class="p2">{{$t('App.dashboard.text32')}}</p>
                    </div>
                    <div class="li">
                        <p class="p1">{{fullScreenTitleData.cicLightCount}}</p>
                        <p class="p2" v-if="domainName != 'plant'">{{$t('App.dashboard.text33')}}</p>
                        <p class="p2" v-if="domainName == 'plant'">{{$t('App.sideBar.text24')}}</p>
                    </div>
                </div>
                <div class="box2">
                    <div class="li">
                        <span class="span1">{{$t('App.dashboard.text37')}}</span>
                        <span class="span2">{{fullScreenTitleData.roomCount}}</span>
                    </div>
                    <div class="li">
                        <span class="span1">{{$t('App.dashboard.text38')}}</span>
                        <span class="span2">{{fullScreenTitleData.aqi}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    import { mapGetters } from 'vuex'
    export default {
        name: 'dashboard',
        data () {
            return {
                homeData:{
                    roomCount:0,
                    deviceCount:0,
                    lightCount:0,
                    lightOnlineCount:0,
                    cicLightCount:0,
                    cicLightOnlineCount:0,
                    sensorCount:0,
                    sensorOnlineCount:0,
                    airPurCount:0,
                    airPurOnlineCount:0,
                    alarmCount:0,
                    purAvg:0,
                },
                alarmInfo:{
                    alarmTotalCount:0,
                    alarmFixed:0,
                    alarmAbnormality:0,
                    alarmTimeout:0,
                },
                hotelViewList:[],
                buildNav:[],
                hotelWeather:{

                },

                echartsLType:0,
                echartsRType:0,
                echartsTime1:null,
                echartsTime2:null,

                password:'',
                code:'',
                checkboxRememberPassword:false,
                codeImage:'',
                value:1,
                roomEnvStatusData:{

                },
                imgErrorSrc:'',

                myChart1:null,
                myChart2:null,
                myChart3:null,
                myChart4:null,
                myChart5:null,
                echartsMinTime:'00',
                echartsMaxTime:'24',
                echartsTimeText:'Last 24 hours',

                pickerOptions:{
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                map:null,
                markerList:[],
                deviceListData:[],
                infowindow:null,

                keywords:'',
                fullScreenShow:false,
                fullScreenMarker:{
                    devObj:{},
                },
                hotelNavList:[],
                fullScreenTitleTop:0,
                fullScreenTitleShow:false,
                fullScreenTitleData:{},

                classificationColorArr:['#00CFAB','#FBF201'],
                classificationArr:['Good','Moderate'],

                classificationArr2:['Excellent','Good','Fair'],
                classificationColorArr2:['#00CFAB','#FBF201','#FEBF00'],

                websocketWeather:null,

                loading:{
                    mapData:false,
                },

                img_lights_0:'',
                img_lights_1:'',
                img_lights_2:'',
                img_lights_3:'',
                img_week_icon:'',
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                number:'number',

                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',

                lastLoginTime:'lastLoginTime',
                avatar:'avatar',

                longitude:'longitude',
                latitude:'latitude',

                headerUpdate:'headerUpdate',
                hotelType:'hotelType',

                isGoogleapis:'isGoogleapis',
                webapiAmap:'webapiAmap',

                domainName: 'domainName',
            }),
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocketWeather){
                this.websocketWeather.close()
            }
        },
        mounted(){
            this.img_lights_0 = require('../img/room/map/lights_0.png');
            this.img_lights_1 = require('../img/room/map/lights_1.png');
            this.img_lights_2 = require('../img/room/map/lights_2.png');
            this.img_lights_3 = require('../img/room/map/lights_3.png');
            this.img_week_icon = require('../img/week_icon.png');
            if(this.version == '1'){
                this.img_lights_0 = require('../img/room/map/lights_0_v1.png');
                this.img_lights_1 = require('../img/room/map/lights_1_v1.png');
                this.img_lights_2 = require('../img/room/map/lights_2_v1.png');
                this.img_lights_3 = require('../img/room/map/lights_3_v1.png');
                this.img_week_icon = require('../img/week_icon_v1.png');
            }
            this.classificationArr2 = [this.$t('App.dashboard.text50'),this.$t('App.dashboard.text51'),this.$t('App.dashboard.text52')]
            this.imgErrorSrc = 'this.src="' + require('../img/user.jpg') + '"';
            
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            let this_ = this;
            // this.getCountryList();
            try {
                if(this.isGoogleapis||this.webapiAmap){
                    this.initMap('#map');
                }
            }catch (e) {
                console.log(e)
            }
            if(this.hotelId){
                this.gethomeData();
                // this.gethotelView();
                this.getHotelWeather();
                this.getAlarmInfo();
                this.roomEnvStatus();
                // this.getEnergyConsumption();
                // this.room_env_status();
                let time = setInterval(function(){
                    if(this_.markerList.length>0&&this_.map){
                        clearInterval(time)
                        for(let i= 0;i<this_.markerList.length;i++){
                            if(this_.hotelId == this_.markerList[i].devObj.id){
                                this_.addDeviceEventListener(this_.markerList[i]);
                                // this_.map.setCenter(new google.maps.LatLng(this_.markerList[i].position.lat(), this_.markerList[i].position.lng()));
                                if(this_.markerList[i].position){
                                    if(this_.version=='0'){
                                        this_.map.setCenter(new google.maps.LatLng(this_.markerList[i].position.lat(),this_.markerList[i].position.lng()));
                                    }else{
                                        this_.map.setCenter(new AMap.LngLat(this_.markerList[i].position.lng(),this_.markerList[i].position.lat()))
                                    }
                                }
                                // console.log(new google.maps.LatLng(this_.markerList[i].position.lat(), this_.markerList[i].position.lng()),'-')
                            }
                        }
                    }
                    // console.log(this_.markerList.length>0,this_.map,'-------ssss-----------')
                },100)

                if(this.websocketWeather){
                    this.websocketWeather.close()
                }
                base.websocket(allUrl.websocket.ws,websocket=>{
                    this.websocketWeather = websocket;
                    websocket.send('{"type":"homeWeather","hotelId":'+this.hotelId+',"dateType":'+this.echartsLType+'}');
                    websocket.onmessage = event => {
                        this.roomEnvStatusData = JSON.parse(event.data).data;
                        if(this.echartsLType == '0'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近24小时';
                            }else{
                                this.echartsTimeText = 'Last 24 hours';
                            }
                        }
                        if(this.echartsLType == '1'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近7天';
                            }else{
                                this.echartsTimeText = 'Last 7 days';
                            }
                        }
                        if(this.echartsLType == '2'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近30天';
                            }else{
                                this.echartsTimeText = 'Last 30 days';
                            }
                        }
                        this.echartsMinTime = this.roomEnvStatusData.timeList[0];
                        this.echartsMaxTime = this.roomEnvStatusData.timeList[this.roomEnvStatusData.timeList.length-1];
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM25_list,'echarts-PM25',1,[35,15])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM10_list,'echarts-PM10',2,[100,20])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.CO2_list,'echarts-CO2',3,[1000,800])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.TVOC_list,'echarts-TVOC',4,[600,200])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.HCHO_list,'echarts-HCHO',5,[100,30])
                    }
                })
            }


            // this.echartsAirQuality();
            // this.getLightingUseSchedule();
            // var lett = this;
            document.onkeydown = function(e) {
                // var key = window.event.keyCode;
                if(this_.fullScreenShow){
                    if(e.key == 'Escape'){
                        this_.fullScreenShow =false;
                        this_.$nextTick(function(){
                            this_.initMap('#map');
                        })
                    }
                }
            }
        },
        methods:{
            fullScreenMouseOver(e,data){
                e.stopPropagation();
                // let left = e.clientX - e.offsetX;
                let top = e.clientY - e.offsetY - 70;
                this.fullScreenTitleData = data;
                this.fullScreenTitleTop = top;
                this.fullScreenTitleShow = true;
                // console.log(left,top)
                // console.log(e.toElement.className)
            },
            fullScreenMouseLeave(){
                this.fullScreenTitleShow =false;
                // e.stopPropagation();
                // console.log(e,data)
            },
            getHotelNavListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getLightList();
                }
            },
            getHotelNavList(callback){
                base.ajax_post(
                    allUrl.siteManagement.hotelNavList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        keywords:this.keywords,
                    },
                    {},
                    data=>{
                        this.hotelNavList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            initMap(name){
                console.log(this.longitude,this.latitude,'------485419---')
                let this_ = this;
                console.log(this.version)
                if(this.version=='1'){
                    const map = new AMap.Map(name.split('#')[1],{
                        center:new AMap.LngLat(this.longitude,this.latitude),
                        zoom:18,
                        expandZoomRange:true,
                        zooms:[3,20],

                        // viewMode:'3D',
                        buildingAnimation: false,
                        showIndoorMap: false,
                    });
                    this.map=map;
                    this.map.setMapStyle('amap://styles/macaron');

                    this.map.setFeatures(['road','bg','point','building']); 
                    // 多个种类要素显示 bg区域面/point兴趣点/road道路及道路标注/building建筑物
                    AMap.plugin([
                        'AMap.ToolBar',
                    ], function(){
                        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
                        this_.map.addControl(new AMap.ToolBar({
                            // 简易缩放模式，默认为 false
                            liteStyle: true
                        }));
                    });
                    /*123高德地图，自定义插件开始*/
                    //步骤 1、
                    AMap.customMapType = function(){};
                    //步骤 2、
                    AMap.customMapType.prototype = {
                        addTo: function(map, dom){
                            dom.appendChild(this._getHtmlDom(map));
                        },
                        _getHtmlDom:function(map){
                            // const _this =this;
                            this.map=map;
                            // 创建一个能承载控件的<div>容器
                            let controlUI = null;
                            this.markerList=[];
                            if(name == '#map'){
                                controlUI = document.createElement('div');
                                controlUI.className = 'iconfont icon-fullscreen';
                                controlUI.style.background = '#fff';
                                controlUI.style.width = '35px';
                                controlUI.style.height = '35px';
                                controlUI.style.lineHeight = '35px';
                                controlUI.style.position = 'absolute';
                                controlUI.style.right = '16px';
                                controlUI.style.bottom = '140px';
                                controlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';

                                controlUI.style.cursor = 'pointer';
                                controlUI.style.textAlign = 'center';
                                controlUI.title = 'Full screen';
                                // controlDiv.appendChild(controlUI);
                                controlUI.addEventListener('click', function() {
                                    // map.setCenter();
                                    this_.fullScreenShow = true;
                                    this_.getHotelNavList();
                                    this_.$nextTick(function(){
                                        this_.initMap('#full_screen_map');
                                        let val = '.dashboard_main .full_screen .sideBar_nav .ul_box .ul';
                                        let timeIndex = 0;
                                        let time = setInterval(function(){
                                            if($(val)&&$(val+' >.select').offset()){
                                                $(val).animate({scrollTop: $(val).scrollTop() + $(val+' >.select').offset().top - $(val).offset().top - 0})
                                                clearInterval(time)
                                            }
                                            timeIndex++;
                                            if(timeIndex>10){
                                                clearInterval(time)
                                            }
                                        },300)
                                    })
                                });
                            }
                            if(name == '#full_screen_map'){
                                  // Set CSS for the control border.
                                controlUI = document.createElement('div');
                                controlUI.className = 'iconfont icon-fullscreen-exit';
                                controlUI.style.background = '#fff';
                                controlUI.style.width = '35px';
                                controlUI.style.height = '35px';
                                controlUI.style.lineHeight = '35px';
                                controlUI.style.position = 'absolute';
                                controlUI.style.right = '16px';
                                controlUI.style.bottom = '140px';
                                controlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';

                                controlUI.style.cursor = 'pointer';
                                controlUI.style.textAlign = 'center';
                                controlUI.title = 'Full screen';
                                // controlDiv.appendChild(controlUI);
                                controlUI.addEventListener('click', function() {
                                    // map.setCenter();
                                    this_.fullScreenShow = false;
                                    this_.$nextTick(function(){
                                        this_.initMap('#map');
                                    })
                                });
                            }
                            return controlUI;
                        },  
                    }
                    /*高德地图，自定义插件*/
                    let createCustomPlugin = function(){
                        let customMapType = new AMap.customMapType(this_.map);
                        this_.map.addControl(customMapType);
                    };
                    /*调用自定义插件的方法*/
                    createCustomPlugin();

                    /*123高德地图，自定义插件结束*/

                    // this.map.setZoom(18);
                    this.infowindow=null;
                    // console.log(centerControl)
                    /*平移或缩放后地图空闲时触发*/
                    this.map.on('moveend',function(){
                        try {
                            this_.getDeviceListData('map')
                            if(this_.infowindow){
                                this_.infowindow.close();
                            }
                        } catch (e) {
                            console.log(e)
                        }
                        
                    })
                    this.map.on('zoomchange',function(){
                        try {
                            this_.getDeviceListData('map')
                            if(this_.infowindow){
                                this_.infowindow.close();
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    })
                    try {
                        this_.getDeviceListData('map')
                    } catch (e) {
                        console.log(e)
                    }
                }else{
                    this.map = new google.maps.Map(document.querySelector(name), {
                        center: new google.maps.LatLng(this.latitude,this.longitude),
                        disableDefaultUI: true, //设置为true,禁用地图上所有控件
                        mapTypeControl: false, //地图类型控制的初始启用/禁用状态。
                        mapTypeId: google.maps.MapTypeId.ROADMAP, //默认加载道路地图视图  动态设置地图类型
                        streetViewControl: false,
                        rotateControl: false,
                        zoomControl: true,
                        zoomControlOptions:{
                            position: google.maps.ControlPosition.RIGHT_BOTTOM,
                        },
                        scrollwheel: true,
                        styles: [
                            {
                                "featureType": "poi",
                                "stylers": [
                                  { "visibility": "off" }
                                ]
                            }
                        ]
                        // draggable: false,
                    });
                    let CenterControl;
                    if(name == '#map'){
                        this.markerList=[];
                        CenterControl =  function(controlDiv) {

                            // Set CSS for the control border.
                            var controlUI = document.createElement('div');
                            controlUI.className = 'iconfont icon-fullscreen';
                            controlUI.style.background = '#fff';
                            controlUI.style.width = '2rem';
                            controlUI.style.height = '2rem';
                            controlUI.style.lineHeight = '2rem';
                            controlUI.style.position = 'relative';
                            controlUI.style.right = '19px';
                            controlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';

                            controlUI.style.cursor = 'pointer';
                            controlUI.style.textAlign = 'center';
                            controlUI.title = 'Full screen';
                            controlDiv.appendChild(controlUI);
                            controlUI.addEventListener('click', function() {
                                // map.setCenter();
                                this_.fullScreenShow = true;
                                this_.getHotelNavList();
                                this_.$nextTick(function(){
                                    this_.initMap('#full_screen_map');
                                    let val = '.dashboard_main .full_screen .sideBar_nav .ul_box .ul';
                                    let timeIndex = 0;
                                    let time = setInterval(function(){
                                        if($(val)&&$(val+' >.select').offset()){
                                            $(val).animate({scrollTop: $(val).scrollTop() + $(val+' >.select').offset().top - $(val).offset().top - 0})
                                            clearInterval(time)
                                        }
                                        timeIndex++;
                                        if(timeIndex>10){
                                            clearInterval(time)
                                        }
                                    },300)
                                })
                            });
                        }
                    }
                    if(name == '#full_screen_map'){
                        this.markerList=[];
                        CenterControl =  function(controlDiv) {
                          // Set CSS for the control border.
                          var controlUI = document.createElement('div');
                          controlUI.className = 'iconfont icon-fullscreen-exit';
                          controlUI.style.background = '#fff';
                          controlUI.style.width = '2rem';
                          controlUI.style.height = '2rem';
                          controlUI.style.lineHeight = '2rem';
                          controlUI.style.position = 'relative';
                          controlUI.style.right = '19px';
                          controlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';

                          controlUI.style.cursor = 'pointer';
                          controlUI.style.textAlign = 'center';
                          controlUI.title = 'Full screen';
                          controlDiv.appendChild(controlUI);
                          controlUI.addEventListener('click', function() {
                            // map.setCenter();
                            this_.fullScreenShow = false;
                            this_.$nextTick(function(){
                                this_.initMap('#map');
                            })
                          });

                        }
                    }

                    var centerControlDiv = document.createElement('div');
                    var centerControl = new CenterControl(centerControlDiv, this.map);

                    centerControlDiv.index = 1;
                    this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centerControlDiv);

                    this.map.setZoom(18);
                    this.infowindow=new InfoBox();
                    console.log(centerControl)
                    /*平移或缩放后地图空闲时触发*/
                    google.maps.event.addListener(this.map, 'idle', function() {
                        try {
                            this_.getDeviceListData('map')
                            // this_.addMarkers([{longitude:114.0686,latitude:22.5315,id:1,name:2223}],'clickListItemType')
                        } catch (e) {
                            console.log(e)
                        }
                    });
                    /*点击地图，关闭infowindow*/
                    google.maps.event.addListener(this.map, 'click', function() {
                        // this_.ib.close();
                        this_.infowindow.close();
                    });
                    /*首次加载地图调用*/
                    google.maps.event.addListenerOnce(this.map, 'tilesloaded', function() {
                        try {
                            this_.getDeviceListData('map')
                            // this_.addMarkers([{longitude:114.0686,latitude:22.5315,id:1,name:2223}],'clickListItemType')
                        } catch (e) {
                            console.log(e)
                        }
                    });
                }
                // this.loading.mapData=false;
            },
            getDeviceListData(clickListItemType,obj){
                if(!this.loading.mapData){
                    console.log(clickListItemType,obj,'00000000000000')
                    let bounds=this.map.getBounds();//获取当前地图边界
                    console.log(bounds)
                    let _lng_low ,_lng_high,_lat_low,_lat_high;
                    // this.map.setCenter(new google.maps.LatLng(parseFloat(obj.latitude), parseFloat(obj.longitude)));
                    // let array=[];
                    // let lngArray=[];
                    // let latArray=[];
                    // let i=0;
                    // for(let index in bounds){
                    //     if(i>=2){
                    //         break;
                    //     }
                    //     i++;
                    //     array.push(bounds[index])
                    // }
                    // i=0;
                    // for(let index in array[1]){
                    //     if(i>=2){
                    //         break;
                    //     }
                    //     i++;
                    //     lngArray.push(array[1][index])
                    // }
                    // i=0;
                    // for(let index in array[0]){
                    //     if(i>=2){
                    //         break;
                    //     }
                    //     i++;
                    //     latArray.push(array[0][index])
                    // }

                    if(this.version=='1'){
                        _lng_low=bounds.southwest.lng;
                        _lng_high=bounds.northeast.lng;
                        _lat_low=bounds.southwest.lat;
                        _lat_high=bounds.northeast.lat;
                    }else{
                        let array=[];
                        let lngArray=[];
                        let latArray=[];
                        let i=0;
                        for(let index in bounds){
                            if(i>=2){
                                break;
                            }
                            i++;
                            array.push(bounds[index])
                        }
                        i=0;
                        for(let index in array[1]){
                            if(i>=2){
                                break;
                            }
                            i++;
                            lngArray.push(array[1][index])
                        }
                        i=0;
                        for(let index in array[0]){
                            if(i>=2){
                                break;
                            }
                            i++;
                            latArray.push(array[0][index])
                        }
                        _lng_low=lngArray[0];
                        _lng_high=lngArray[1];
                        _lat_low=latArray[0];
                        _lat_high=latArray[1];
                    }
                    
                    //当为搜索时，传入对应的搜索内容即可，经纬度范围为当前地图的边界，后台会做处理
                    base.ajax_post(
                        allUrl.dashboard.homeMap,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            lng_low:_lng_low,
                            lng_high:_lng_high,
                            lat_low:_lat_low,
                            lat_high:_lat_high,
                        },
                        {},
                        data =>{
                            this.deviceListData=data.data.list;
                            this.addMarkers(this.deviceListData,clickListItemType)
                            this.loading.mapData=false;
                        },
                    this,()=>{
                        this.loading.mapData=false;
                    })
                }
            },
            addMarkers(deviceList,clickListItemType){
                let this_ = this;
                let filterDevices=[];//筛选动态获取的设备对象数组，存储过滤后的设备
                if(clickListItemType!='map'){
                    //当点击地图上方的搜索时，需清除地图上的marker
                    if(this_.version==='0'){
                        this_.map.clearMap();
                        
                    }else{
                        this_.markerList.forEach(marker=>{
                            marker.setMap(null);
                        })
                       
                    }
                    this.markerList=[];
                    filterDevices=deviceList;
                    this.loading.mapData=true;
                }else{
                    if(this_.markerList.length>0){
                        for(let i= 0;i<deviceList.length;i++){
                            let flag = true;
                            for(let j=0;j<this_.markerList.length;j++){
                                //id不唯一，id+devType才唯一
                                // console.log(deviceList[i])
                                if(deviceList[i].id==this_.markerList[j].devObj.id){
                                   deviceList[i].imageActive = this_.markerList[j].devObj.imageActive;
                                    this_.markerList[j].devObj=deviceList[i];//更新数据
                                    flag=false;
                                    break;
                                }
                            }
                            if(flag){
                                filterDevices.push(deviceList[i])
                            }
                        }
                    }else{
                        //首次动态获取设备
                        filterDevices=deviceList;
                    }
                }

                let imgUrlPrefix='./img/';//图片前缀
                let imageNormal=imgUrlPrefix+'hotel_0.png';
                let imageActive=imgUrlPrefix+'hotel_1.png';
                if(this.version == '0'){
                    let normalSize = new google.maps.Size(34, 31);
                    let anchorPoint=new google.maps.Point(17, 15);
                    let iconNormal = {
                        url:imageNormal,
                        size:normalSize,
                        scaledSize:normalSize,
                        anchor:anchorPoint,
                    }
                    let iconActive = {
                        url:imageActive,
                        size:normalSize,
                        scaledSize:normalSize,
                        anchor:anchorPoint,
                    }
                     //准备marker和icon
                    filterDevices.forEach(item=>{
                        let marker = new google.maps.Marker({
                            position:new google.maps.LatLng(item.latitude,item.longitude),
                            icon:iconNormal,
                            map: this_.map,
                        });

                        marker.devObj=item

                        marker.iconNormal=iconNormal
                        marker.iconActive=iconActive

                        this_.markerList.push(marker)
                        google.maps.event.addListener(marker, 'click', function(e) {
                            let flag =this_.addDeviceEventListener(marker,'click');
                            // /*在地图上点击设备，需弹出操作菜单*/
                            if(flag){
                                // this_.openOperationPanel(markerListTemper[i])
                                console.log(marker,e)
                            }
                        })
                        google.maps.event.addListener(marker, 'mouseover', ()=> {
                            this_.hotelMouseover(marker);
                            // console.log(e)
                        })
                    })
                }else if(this.version == '1'){
                    let normalSize=new AMap.Size(34, 31);// 图标尺寸
                    // let activesize=new AMap.Size(30, 30);// 激活图标尺寸
                    let _pixel=new AMap.Pixel(17, 15);//点标记显示位置偏移量，使图片处于点坐标的正中心
                    // let anchorPoint=new google.maps.Point(17, 15);
                    let iconNormal  = new AMap.Icon({
                        size: normalSize,
                        image: imageNormal,  // 默认Icon图像
                        imageSize:normalSize,
                    });
                    //激活情况下的图标
                    let iconActive = new AMap.Icon({
                        size: normalSize,  // 图标尺寸，激活情况下的尺寸一样大
                        image: imageActive,  // 激活Icon图像
                        imageSize:normalSize,
                    });

                     //准备marker和icon
                    filterDevices.forEach(item=>{
                        let marker = new AMap.Marker({
                            position:new AMap.LngLat(item.longitude,item.latitude),
                            offset: _pixel,
                            icon: imageNormal, // 添加 Icon 图标 URL
                            // size: normalSize,
                        });
                        marker.devObj=item

                        marker.iconNormal=iconNormal
                        marker.iconActive=iconActive

                        this_.markerList.push(marker)
                        marker.on('click',function(){
                            let flag =this_.addDeviceEventListener(marker,'click');
                            /*在地图上点击设备，需弹出操作菜单*/
                            if(flag){
                                // this_.openOperationPanel(marker)
                                console.log(flag)
                            }
                        })
                        .on('mouseover',function(){
                            this_.hotelMouseover(marker);
                        })
                    })
                    this.map.add(this_.markerList);
                }

                for(let i= 0;i<this.markerList.length;i++){
                    this.markerList[i].setIcon(this.markerList[i].iconNormal)
                    if(this.hotelId == this.markerList[i].devObj.id){
                        // this.addDeviceEventListener(this.markerList[i]);
                        this.fullScreenMarker = this.markerList[i];
                        this.markerList[i].setIcon(this.markerList[i].iconActive)
                    }
                }
            },
            fullScreenMapClick(item){
                console.log(item.id,this.hotelId)
                if(item.id != this.hotelId){
                    let this_ = this;
                    if(this.version=='0'){
                        this.map.setCenter(new google.maps.LatLng(this.latitude,this.longitude));
                    }else{
                        this.map.setCenter(new AMap.LngLat(this.longitude,this.latitude))
                    }
                    // this.map.setCenter(new google.maps.LatLng(item.latitude,item.longitude))
                    let timeIndex = 0;
                    let time = setInterval(function(){
                        this_.$nextTick(function(){
                            for(let i= 0;i<this_.markerList.length;i++){
                                if(item.id == this_.markerList[i].devObj.id){
                                    console.log(item.id,this_.markerList[i].devObj.id,'=============')
                                    this_.addDeviceEventListener(this_.markerList[i]);
                                    clearInterval(time)
                                }
                            }
                            timeIndex++;
                            if(timeIndex>10){
                               clearInterval(time) 
                            }
                        })
                    },300)
                }
            },
            addDeviceEventListener(marker){
                this.fullScreenMarker = marker;
                // this.map.setCenter(new google.maps.LatLng(marker.position.lat(),marker.position.lng()));
                console.log(marker)
                var storage = window.localStorage;
                storage.setItem('countryIdNav',marker.devObj.countryId);
                storage.setItem('provinceIdNav',marker.devObj.proId);
                storage.setItem('cityIdNav',marker.devObj.cityId);
                storage.setItem('hotelIdNav',marker.devObj.id);
                this.$store.commit('HEADERIDFUN',{
                    headerUpdate: this.headerUpdate+1,
                })
                // this.$store.commit('HEADERLOGO',{
                //     headerLogo: marker.devObj.logo,
                // })
                // this.$store.commit('HEADERIDFUN',{
                //     hotelId: marker.devObj.id,
                // })
                this.$store.commit('LONLATFUN',{
                    longitude: marker.devObj.longitude,
                    latitude: marker.devObj.latitude,
                })
                for(let i= 0;i<this.markerList.length;i++){
                    this.markerList[i].setIcon(this.markerList[i].iconNormal)
                }
                marker.setIcon(marker.iconActive)
            },
            hotelMouseover(marker){
                if(this.infowindow){
                    this.infowindow.close();
                }
                let content=`<div class="lamp-control-map-style">
                        <div class="div1">
                            <div class="left"><img src="${marker.devObj.avatar}"/></div>
                            <div class="right">
                                <p class="p1">${marker.devObj.name}</p>
                                <p class="p2">${marker.devObj.location}</p>
                            </div>
                        </div>
                        <div class="div2">
                            <div class="li">
                                <p class="p1">${marker.devObj.airPurCount}</p>
                                <p class="p2">${this.$t("App.dashboard.text35")}</p>
                            </div>
                            <div class="li">
                                <p class="p1">${marker.devObj.sensorCount}</p>
                                <p class="p2">${this.$t("App.dashboard.text34")}</p>
                            </div>
                            <div class="li">
                                <p class="p1">${marker.devObj.lightCount}</p>
                                <p class="p2">${this.$t("App.dashboard.text32")}</p>
                            </div>
                            <div class="li">
                                <p class="p1">${marker.devObj.cicLightCount}</p>
                                <p class="p2" v-if="domainName != 'plant'">${this.$t("App.dashboard.text33")}</p>
                                <p class="p2" v-if="domainName == 'plant'">${this.$t("App.sideBar.text24")}</p>
                            </div>

                        </div>
                    </div>`;
                
                if(this.version =='1'){
                    this.infoWindow = new AMap.InfoWindow({
                        isCustom: true,
                        closeWhenClickMap:true,
                        autoMove:true,
                        anchor:'middle-left',
                        //基点指向marker的头部位置
                        offset: new AMap.Pixel(50, 25)
                    });
                    //要想动态的改变数据，则需要使用setContent方法才行
                    this.infoWindow.setContent(content);
                    this.infoWindow.open(this.map, marker.getPosition());
                }else{
                    this.infowindow.setOptions({pixelOffset:new google.maps.Size(30, -65),content:content});
                    this.infowindow.open(this.map, marker);
                }

            },

            linkToFun(val,type,data){
                var storage = window.localStorage;
                if(val != this.routerStr){
                    this.$router.push({path:val});
                    this.$store.commit('ROUTERSTRFUN',{
                        routerStr:val,
                    })
                }
                if(type == 'ordinary'){
                    storage.setItem('roomRoomId','');
                    storage.setItem('roomRoomName','');
                    storage.setItem('buildId',data.id);
                    storage.setItem('deviceType','0');
                    storage.setItem('buildIdName',data.name);
                }
                if(type == 'circadian'){
                    storage.setItem('roomRoomId','');
                    storage.setItem('roomRoomName','');
                    storage.setItem('deviceType','1');
                    storage.setItem('buildId',data.id);
                    storage.setItem('buildIdName',data.name);
                }
                if(type == 'purifier'){
                    storage.setItem('roomRoomId','');
                    storage.setItem('roomRoomName','');
                    storage.setItem('deviceType','3');
                    storage.setItem('buildId',data.id);
                    storage.setItem('buildIdName',data.name);
                }
                if(type == 'sensor'){
                    storage.setItem('roomRoomId','');
                    storage.setItem('roomRoomName','');
                    storage.setItem('deviceType','2');
                    storage.setItem('buildId',data.id);
                    storage.setItem('buildIdName',data.name);
                }
            },
            echartsLTypeFun(val){
                this.echartsLType = val;
                this.roomEnvStatus()
                if(this.websocketWeather){
                    this.websocketWeather.close()
                }
                base.websocket(allUrl.websocket.ws,websocket=>{
                    this.websocketWeather = websocket;
                    websocket.send('{"type":"homeWeather","hotelId":'+this.hotelId+',"dateType":'+this.echartsLType+'}');
                    websocket.onmessage = event => {
                        this.roomEnvStatusData = JSON.parse(event.data).data;
                        if(this.echartsLType == '0'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近24小时';
                            }else{
                                this.echartsTimeText = 'Last 24 hours';
                            }
                        }
                        if(this.echartsLType == '1'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近7天';
                            }else{
                                this.echartsTimeText = 'Last 7 days';
                            }
                        }
                        if(this.echartsLType == '2'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近30天';
                            }else{
                                this.echartsTimeText = 'Last 30 days';
                            }
                        }
                        this.echartsMinTime = this.roomEnvStatusData.timeList[0];
                        this.echartsMaxTime = this.roomEnvStatusData.timeList[this.roomEnvStatusData.timeList.length-1];
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM25_list,'echarts-PM25',1,[35,15])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM10_list,'echarts-PM10',2,[100,20])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.CO2_list,'echarts-CO2',3,[1000,800])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.TVOC_list,'echarts-TVOC',4,[600,200])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.HCHO_list,'echarts-HCHO',5,[100,30])
                    }
                })
                // if(val == '3'){
                //     this.$refs.echartsTime1.focus()
                // }else{
                //     this.echartsTime1 = null;
                //     this.getEnergyConsumption();
                // }
            },
            echartsRTypeFun(val){
                console.log(this.$refs.echartsTime2)
                this.echartsRType = val;
                if(val == '3'){
                    this.$refs.echartsTime2.focus()
                }else{
                    this.echartsTime2 = null;
                    // this.getLightingUseSchedule();
                }
            },
            echartsTime1Change(){
                this.getEnergyConsumption();
            },
            // echartsTime2Change(){
            //     // this.getLightingUseSchedule();
            // },
            getHotelWeather(){
                base.ajax_post(
                    allUrl.dashboard.getHotelWeather,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.hotelWeather = data.data;
                    },
                    this
                )
            },
            /*首页概览数据*/
            getAlarmInfo(){
                base.ajax_post(
                    allUrl.dashboard.alarmInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.alarmInfo = data.data;
                    },
                    this
                )
            },
            /*首页空气质量跟传感器平均数据*/
            roomEnvStatus(){
                base.ajax_post(
                    allUrl.dashboard.roomEnvStatus,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        type:this.echartsLType,
                    },
                    {},
                    data=>{
                        this.roomEnvStatusData = data.data;
                        if(this.echartsLType == '0'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近24小时';
                            }else{
                                this.echartsTimeText = 'Last 24 hours';
                            }
                        }
                        if(this.echartsLType == '1'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近7天';
                            }else{
                                this.echartsTimeText = 'Last 7 days';
                            }
                        }
                        if(this.echartsLType == '2'){
                            if(this.version == '1'){
                                this.echartsTimeText = '最近30天';
                            }else{
                                this.echartsTimeText = 'Last 30 days';
                            }
                        }
                        this.echartsMinTime = this.roomEnvStatusData.timeList[0];
                        this.echartsMaxTime = this.roomEnvStatusData.timeList[this.roomEnvStatusData.timeList.length-1];
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM25_list,'echarts-PM25',1,[35,15])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM10_list,'echarts-PM10',2,[100,20])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.CO2_list,'echarts-CO2',3,[1000,800])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.TVOC_list,'echarts-TVOC',4,[600,200])
                        this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.HCHO_list,'echarts-HCHO',5,[100,30])
                        // this.echartsAirQuality(data.data.timeList,data.data.dataList)
                    },
                    this
                )
            },
            gethomeData(){
                base.ajax_post(
                    allUrl.dashboard.homeData,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.homeData = data.data;
                    },
                    this
                )
            },
            /*酒店概览列表*/
            gethotelView(){
                base.ajax_post(
                    allUrl.dashboard.hotelView,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                    },
                    {},
                    data=>{
                        this.hotelViewList = data.data.list;
                    },
                    this
                )
            },
            plSwitchFun(val){
                if(val == 0){
                    this.value = 1
                }else{
                    this.value = 0
                }
            },
            getCodeImage(){
                base.ajax_post(
                    allUrl.login.get_code_image,
                    {},
                    {},
                    data=>{
                        this.codeImage = data.data.path;
                    },
                    this
                )
            },
            openPage(val){
                window.open('/'+val);
            },
            echartsAirQuality(timeList,dataList,className,index,numberArr){
                let this_ = this;
                // console.log(timeList,dataList)
                this['myChart'+index] = this.$echarts.init(document.getElementsByClassName(className)[0]);
                this['myChart'+index].setOption({
                    tooltip:{
                        trigger: 'axis',
                        padding:0,
                        borderColor:'#fff',
                        axisPointer:{
                            lineStyle:{
                                color:'rgba(0,0,0,0)',
                                type:'dotted',
                            }
                        },
                        formatter: function (params) {
                            // console.log(params)
                            let i = 0;
                            if(params[0].value >numberArr[0]){
                                i = 2
                            }else if(params[0].value >numberArr[1]){
                                i = 1
                            }else{
                                i = 0
                            }
                            var tls = `<div class="echarts_indoor_tooltip">
                                <p class="p1">${this_.classificationArr2[i]} : ${params[0].value}</p>
                            </div>`;
                                // <p class="p2">${params[0].name}</p>
                           return tls;
                        },
                    },
                    grid:{
                        top:10,
                        left:20,
                        right:40,
                        bottom:10,
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: timeList,
                        // offset:20,
                        axisLine:{
                            // show:false,
                            lineStyle:{
                                color:'rgba(255, 255, 255, 1)',
                            }
                        },
                        axisTick:{
                            show:true,
                            // inside:false,
                            lineStyle:{
                                color:'rgba(255, 255, 255, 0.2)',
                            }
                        },
                        axisLabel:{
                            show:false,
                            // margin:10,
                            color:'rgba(255,255,255,1)',
                            fontStyle:'PingFang-SC-Medium,PingFang-SC',
                            fontSize:'0.67rem',
                            fontWeight:'500',
                        },
                    },
                    yAxis: {
                        // show:false,
                        type: 'value',
                        // nameGap:6,
                        splitNumber:3,
                        axisTick:{
                            show:false,
                        },
                        axisLine:{
                            // show:false,
                            lineStyle:{
                                color:'rgba(255, 255, 255, 1)',
                            }
                        },
                        axisLabel:{
                            show:false,
                            color:'rgba(255,255,255,1)',
                            fontStyle:'PingFang-SC-Medium,PingFang-SC',
                            fontSize:'0.67rem',
                            fontWeight:'500',
                        },
                        splitLine:{
                            show:false,
                        }
                    },
                    series: [{
                        data: dataList,
                        type: 'line',
                        // symbol:'none',
                        symbol:'circle',showSymbol: false,
                        smooth:true,
                        lineStyle:{
                            width:1,
                            color:'rgba(255, 255, 255, 1)',
                        },
                        itemStyle:{
                            // color:'#FEBF00',
                            // borderColor:'rgba(255, 255, 255, 1)',
                            // borderWidth:3,
                            color: function (params) {
                                if(params.value>numberArr[0]){
                                    return this_.classificationColorArr2[2]
                                }else if(params.value>numberArr[1]){
                                    return this_.classificationColorArr2[1]
                                }else{
                                    return this_.classificationColorArr2[0]
                                }
                            }
                        },
                        areaStyle: {
                            opacity:0.5,
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#FFF' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#FFF' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        },
                    }]
                });
            },
            getEnergyConsumption(){
                let date,isTrue = false;
                if(this.echartsLType !=3){
                    isTrue = true;
                }else{
                    if(this.echartsTime1){
                        isTrue = true;
                        date = this.echartsTime1[0]+'/'+this.echartsTime1[1]
                    }

                }
                if(isTrue){
                    base.ajax_post(
                        allUrl.dashboard.roomTemAvg,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                            dateType:this.echartsLType,
                            date:date,
                        },
                        {},
                        data=>{
                            this.energyConsumption(data.data)
                        },
                        this
                    )
                }else{
                    this.energyConsumption({
                        dataList:[],
                        timeList:[],
                    })
                }
            },
            energyConsumption(data){
                console.log(data)
                this.$nextTick(function(){
                    if(document.getElementsByClassName('energy_consumption')[0]){
                        this.myChart2 = this.$echarts.init(document.getElementsByClassName('energy_consumption')[0]);
                        this.myChart2.setOption({
                            tooltip:{
                                trigger:'axis',
                                axisPointer:{
                                    type : 'line',
                                    snap:true,
                                },
                                padding:0,
                                formatter: function (params) {
                                    // console.log(params)
                                    var tls = `<div class="history_echarts_tooltip"><p class="p1"><i style="background-color:${params[0].color}"></i><span class="span1">${params[0].value}</span><span class="span1">℃</span></p><p class="p2">${params[0].name}</p></div>`;
                                   return tls;
                                },
                            },
                            grid:{
                                top:10,
                                left:40,
                                right:50,
                                bottom:40,
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: false,
                                data: data.timeList,
                                axisTick:{
                                    show:false,
                                    alignWithLabel: true
                                },
                                axisLine:{
                                    show:false
                                },
                                axisLabel:{
                                    color:'rgba(163,175,187,1)',
                                    fontStyle:'AlibabaPuHuiTiR',
                                    fontSize:'1rem',
                                },
                            },
                            yAxis: {
                                type: 'value',
                                nameGap:6,
                                splitNumber:4,
                                axisTick:{
                                    show:false,
                                },
                                axisLine:{
                                    show:false
                                },
                                splitLine:{
                                    lineStyle:{
                                        color:'rgba(235,239,242,1)'
                                    }
                                },
                                axisLabel:{
                                    color:'rgba(163,175,187,1)',
                                    fontStyle:'AlibabaPuHuiTiR',
                                    fontSize:'1rem',
                                },
                            },
                            series: [{
                                data: data.dataList,
                                type: 'line',
                                smooth:true,
                                barWidth:null,
                                symbol:'none',
                                lineStyle:{
                                    color:'rgba(255,190,0,1)',
                                },
                                itemStyle:{
                                    color:'rgba(255,190,0,1)',
                                },
                            }]
                        });
                    }
                })
            },
        },
        watch:{
            longitude:function(){
                console.log(this.longitude,'-]]ll')
            },
            isGoogleapis:function(){
                this.initMap('#map');
            },
            webapiAmap:function(){
                this.initMap('#map');
            },
            hotelId:function(){
                console.log('hotelId')
                if(this.hotelId){
                    this.gethomeData();
                    this.gethotelView();
                    this.getHotelWeather();
                    this.getAlarmInfo();
                    this.roomEnvStatus();
                    // this.getEnergyConsumption();

                    if(this.isGoogleapis||this.webapiAmap){
                        if(this.version=='0'){
                            this.map.setCenter(new google.maps.LatLng(this.latitude,this.longitude));
                        }else{
                            this.map.setCenter(new AMap.LngLat(this.longitude,this.latitude))
                        }
                    }
                    if(this.websocketWeather){
                        this.websocketWeather.close()
                    }
                    base.websocket(allUrl.websocket.ws,websocket=>{
                        this.websocketWeather = websocket;
                        websocket.send('{"type":"homeWeather","hotelId":'+this.hotelId+',"dateType":'+this.echartsLType+'}');
                        websocket.onmessage = event => {
                            this.roomEnvStatusData = JSON.parse(event.data).data;
                            if(this.echartsLType == '0'){
                                if(this.version == '1'){
                                    this.echartsTimeText = '最近24小时';
                                }else{
                                    this.echartsTimeText = 'Last 24 hours';
                                }
                            }
                            if(this.echartsLType == '1'){
                                if(this.version == '1'){
                                    this.echartsTimeText = '最近7天';
                                }else{
                                    this.echartsTimeText = 'Last 7 days';
                                }
                            }
                            if(this.echartsLType == '2'){
                                if(this.version == '1'){
                                    this.echartsTimeText = '最近30天';
                                }else{
                                    this.echartsTimeText = 'Last 30 days';
                                }
                            }
                            this.echartsMinTime = this.roomEnvStatusData.timeList[0];
                            this.echartsMaxTime = this.roomEnvStatusData.timeList[this.roomEnvStatusData.timeList.length-1];
                            this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM25_list,'echarts-PM25',1,[35,15])
                            this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.PM10_list,'echarts-PM10',2,[100,20])
                            this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.CO2_list,'echarts-CO2',3,[1000,800])
                            this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.TVOC_list,'echarts-TVOC',4,[600,200])
                            this.echartsAirQuality(this.roomEnvStatusData.timeList,this.roomEnvStatusData.HCHO_list,'echarts-HCHO',5,[100,30])
                        }
                    })
                    
                }
            },
            updateRemRatio:function(){
                this.$nextTick(function(){
                    if(this.myChart1){
                        this.myChart1.resize();
                    }
                    if(this.myChart2){
                        this.myChart2.resize();
                    }
                    if(this.myChart3){
                        this.myChart3.resize();
                    }
                    if(this.myChart4){
                        this.myChart4.resize();
                    }
                    if(this.myChart5){
                        this.myChart5.resize();
                    }
                })
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .dashboard_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 62rem;
        min-width: 119rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .dashboard_right{
                .dashboard_right_box3{
                    .right_data_right{
                        background:linear-gradient(132deg,rgba(183,153,214,1) 0%,rgba(110,74,188,1) 100%);
                    }
                }
                .dashboard_right_box1{
                    .right_top_box1{
                        .right_top_box1_b{
                            background-image: url(../img/dashboard_bg_v1.png);
                            .p{
                                margin-bottom: 1rem;
                                .span2{
                                    color: #FFDB00;
                                    i{
                                        margin: 0 0.5rem;
                                    }
                                }
                            }
                        }
                    }

                }
                .dashboard_right_box2{
                    .right_top_box2{
                        .text_box{
                            .div2{
                                .box1{
                                    background:linear-gradient(360deg,rgba(27,181,163,1) 0%,rgba(49,212,193,1) 100%);
                                }
                                .box2{
                                    .box2_right{
                                        .title{
                                            color: #513C93;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .dashboard_right_box3{
                }
            }
            .full_screen{
                .title{
                    .box2{
                        .li{
                            background:rgba(81,60,147,0.1);
                            .span2{
                                color:rgba(81,60,147,1);
                            }
                        }
                    }
                }
                .sideBar_nav{
                    .title_box{
                        .box2{
                            .li{
                                background:rgba(81,60,147,0.1);
                                .span2{
                                    color:rgba(81,60,147,1);
                                }
                            }
                        }
                    }
                    .ul_box{
                        .search{
                            .el-input{
                                .el-icon-search{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                            }
                        }
                        .ul{
                            &.scrollbar_style::-webkit-scrollbar-thumb{
                                background-color:#634B97;
                            }
                            .li{
                                &:hover{
                                    .right{
                                        .iconfont{
                                            color:#634B97;
                                        }
                                    }
                                }
                                &.select{
                                    .right{
                                        .iconfont{
                                            color:#634B97;
                                        }
                                    }
                                }
                            }
                        }
                    } 
                }
            }
        }
        .dashboard_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .dashboard_right{
            position: relative;
            padding: 1.92rem 1.67rem 0;
            width: calc(100% - 11.67rem);
            // min-width: 120px;
            display: flex;
            .dashboard_right_box1{
                display: flex;
                .right_top_box1{
                    position: relative;
                    width:29rem;
                    .right_top_box1_b{
                        width: 100%;
                        height: calc(100% - 2rem);
                        padding-left: 1.83rem;
                        background-image: url(../img/dashboard_bg.png);
                        background-size: 100% 100%;
                        background-position: center;
                        border-radius: 0.9rem;
                        overflow: hidden;
                        // padding: 0 2.5rem;
                        .title{
                            margin-top: 2rem;
                            font-family: AlibabaPuHuiTiM;
                            font-size: 2rem;
                            color: #FFFFFF;
                            margin-bottom: 1rem;
                        }
                        .div{
                            // border-left: 0.1rem solid #FFFFFF;
                            // padding-left: 0.8rem;
                        }
                        .p{
                            display: flex;
                            align-items: center;
                            // justify-content: space-between;
                            margin-bottom: 0.8rem;
                            // width: 22rem;
                            height: 1.5rem;line-height:1.5rem;
                            .span1{
                                font-family: AlibabaPuHuiTiM;
                                font-size: 1.1rem;
                                color: #FFFFFF;
                                display: flex;
                                align-items: center;
                                .i{
                                    display: inline-block;
                                    width: 1.8rem;height: 1.8rem;
                                    border-radius: 50%;
                                    background-image: url('../img/dashboard_bg_icon.png');
                                    background-size: 100% 100%;
                                    background-position: center;
                                    margin-right: 0.5rem;
                                    // background: 
                                }
                                .remarks{
                                    margin: 0 0.2rem;
                                    font-size: 0.8rem;
                                }
                            }
                            .span2{
                                // width: 5rem;
                                font-size:1.2rem;
                                font-family:AlibabaPuHuiTiM;
                                color:rgba(255,219,0,1);
                                i{
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
            }
            .dashboard_right_box2{
                // width: 48rem;
                width: calc(100% - 53rem);
                .right_top_box2{
                    background:linear-gradient(180deg,rgba(1,111,184,1) 0%,rgba(117,120,210,1) 100%);
                    margin-left: 1.67rem;
                    flex:1;
                    border-radius: 0.83rem;height: 28.5rem;
                    // background: #FFFFFF;
                    border: 1px solid #EBEFF2;
                    padding: 1.9rem 1.67rem 1.3rem;
                    .top-box{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 1.5rem;line-height:1.5rem;
                        .left{
                            .span1{
                                font-size:1.25rem;
                                font-family:AlibabaPuHuiTiH;
                                color:rgba(255,255,255,1);
                            }
                            .span2{
                                font-size:1rem;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                            }
                        }
                        .right{
                            display: flex;
                            position: relative;
                            padding-right: 2rem;
                            .btn{
                                background-color: #FFF;
                                border: none;
                                padding:0 0.5rem;
                                margin-left: 0.4rem;
                                font-size:1rem;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(0,207,171,1);
                                border-radius: 0.75rem;
                                cursor: pointer;
                                &.select{
                                    background-color: #00CFAB;
                                    color:rgba(255,255,255,1);
                                }
                            }
                            .tis-btn{
                                position: absolute;
                                top: -1rem;right: -0.4rem;
                                width: 1.8rem;height: 2rem;
                                background-image: url('../img/tis-btn0.png');
                                background-size: 100% 100%;
                                background-position: center;
                                &:hover{
                                    background-image: url('../img/tis-btn1.png');
                                    .hover-div,.tis-box{
                                        display: block;
                                    }
                                }
                                .hover-div{
                                    position: absolute;
                                    z-index: 1000;
                                    top: 0rem;right: 0rem;
                                    width: 47.5rem;height: 3rem;
                                    background:rgba(0,0,0,0);
                                    display: none;
                                }
                                .tis-box{
                                    display: none;
                                    position: absolute;
                                    z-index: 1000;
                                    top: 3rem;right: 0rem;
                                    width: 47.5rem;
                                    background:#F6F8FC;
                                    border-radius: 1rem;
                                    padding:0 1.67rem 1.6rem;
                                    &::after {
                                        position: absolute;
                                        z-index: -1;
                                        top: -0.2rem;right: 2.5rem;
                                        content: '';
                                        display: inline-block;
                                        width: 2rem;
                                        height: 2rem;
                                        background:#F6F8FC;
                                        transform: rotate(110deg) skew(50deg);
                                    }
                                    .tis-title{
                                        height: 2rem;line-height: 2rem;
                                        font-size:1rem;
                                        font-family:PingFangSC-Regular,PingFang SC;
                                        font-weight:400;
                                        color:rgba(51,51,51,1);
                                    }
                                    .tis-ul{
                                        display: flex;
                                        font-size:1rem;
                                        font-family:PingFangSC-Regular,PingFang SC;
                                        font-weight:400;
                                        color:rgba(101,112,133,1);
                                        .tis-li{
                                            .tis-item{
                                                height: 1.8rem;line-height:1.8rem;
                                                text-align: center;
                                            }
                                            &:nth-child(1){
                                                flex: 7;
                                                .tis-item{
                                                    &:nth-child(2n){
                                                        background:rgba(207,231,251,1);
                                                    }
                                                    &:nth-child(2n+1){
                                                        background:rgba(194,220,238,1);
                                                    }
                                                }
                                            }
                                            &:nth-child(2){
                                                flex: 3;
                                                .tis-item{
                                                    &:nth-child(2n){
                                                        background:rgba(245,249,249,1);
                                                    }
                                                    &:nth-child(2n+1){
                                                        background:rgba(234,238,238,1);
                                                    }
                                                }
                                            }
                                            &:nth-child(3){
                                                flex: 3;
                                                .tis-item{
                                                    &:nth-child(2n){
                                                        background:rgba(100,223,202,1);
                                                    }
                                                    &:nth-child(2n+1){
                                                        background:rgba(91,213,191,1);
                                                    }
                                                }
                                            }
                                            &:nth-child(4){
                                                flex: 3;
                                                .tis-item{
                                                    &:nth-child(2n){
                                                        background:rgba(251,243,100,1);
                                                    }
                                                    &:nth-child(2n+1){
                                                        background:rgba(240,233,91,1);
                                                    }
                                                }
                                            }
                                            &:nth-child(5){
                                                flex: 3;
                                                .tis-item{
                                                    &:nth-child(2n){
                                                        background:rgba(250,214,99,1);
                                                    }
                                                    &:nth-child(2n+1){
                                                        background:rgba(241,203,88,1);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .ul{
                        margin-top: 1rem;
                        .li{
                            display: flex;
                            align-items: center;
                            height:4rem;line-height:4rem;
                            background:rgba(255,255,255,0.1);
                            border-radius:0.5rem;
                            margin-bottom: 0.8rem;
                            position: relative;
                            .echarts-minTime{
                                position: absolute;
                                bottom: 5px;right: calc(100% - 35rem);
                                line-height:initial;
                                font-size:0.7rem;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                            }
                            .echarts-maxTime{
                                position: absolute;
                                bottom:5px;left: calc(100% - 35px);
                                line-height:initial;
                                font-size:0.7rem;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                            }
                            .div1{
                                margin-left: 1.1rem;
                                width: 5rem;
                                height: 4rem;
                            }
                            .div2{
                                width: 14rem;
                                height: 4rem;
                            }
                            .div3{
                                width: 14rem;
                                height: 4rem;
                            }
                            .text1{
                                font-size:1.2rem;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                            }
                            .text2{
                                font-size:1.8rem;
                                font-family:AlibabaPuHuiTiH;
                                color:rgba(255,255,255,1);
                            }
                            .text3{
                                margin-left: 0.2rem;
                                font-size:1rem;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(255,255,255,1);
                            }
                            .text4{
                                margin-left: 0.5rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiH;
                                color:rgba(251,242,1,1);
                            }
                            .echarts{
                                // width: 12rem;
                                flex: 1;
                                height: 4rem;
                                .echarts_indoor_tooltip{
                                    padding:0 1rem;
                                    background-color: #fff;
                                    font-size:0.8rem;
                                    font-family:PingFangSC-Regular,PingFang SC;
                                    font-weight:400;
                                    color:rgba(51,51,51,1);
                                }
                            }
                        }
                    }
                    // .img_box{
                    //     position: relative;
                    //     top: -1.5rem;
                    //     width: 9.4rem;
                    //     height: 22rem;
                    //     padding: 0 0.5rem;
                    //     img{
                    //         width: 100%;
                    //         height: 100%;
                    //     }
                    // }
                    // .text_box{
                    //     // margin-left: 1.6rem;
                    //     // width: calc(100% - 11rem);
                    //     .div1{
                    //         display: flex;
                    //         align-items: center;
                    //         justify-content: space-between;
                    //         height: 4.67rem;line-height: 4.67rem;
                    //         .left{
                    //             font-family: PingFang-SC-Heavy;
                    //             font-size: 2rem;
                    //             color: #333333;
                    //         }
                    //     }
                    //     .div2{
                    //         // display: flex;
                    //         // justify-content: space-between;
                    //         .box{
                    //             // padding-left: 1.42rem;
                    //             border-radius:1rem;
                    //             // flex: 1;
                    //             // border-radius: 12px;
                    //         }
                    //         .box1{
                    //             height: 10.42rem;
                    //             // width: 45rem;
                    //             background-image: linear-gradient(180deg, #A3FAEB 0%, #2FA5E4 79%);
                    //             display: flex;
                    //             .left{
                    //                 // width: 34.5rem;
                    //                 flex: 1;
                    //                 margin-top: 1rem;
                    //                 .title{
                    //                     padding-left: 1.42rem;
                    //                     font-size:1.17rem;
                    //                     font-family:AlibabaPuHuiTiH;
                    //                     color:rgba(255,255,255,1);
                    //                 }
                    //                 .echarts_airQuality{
                    //                     width: 100%;
                    //                     height: 7rem;

                    //                     .echarts_airQuality_tooltip{
                    //                         background-color:#fff;
                    //                         padding: 0.3rem 1rem 0.67rem 0;
                    //                         .p1{
                    //                             display: flex;
                    //                             align-items: center;
                    //                             font-size:1rem;
                    //                             font-family:AlibabaPuHuiTiM;
                    //                             color:rgba(51,51,51,1);
                    //                             i{
                    //                                 background: #05CFAB !important;
                    //                                 margin-left: 0.92rem;
                    //                                 margin-right: 0.5rem;
                    //                                 display: inline-block;
                    //                                 width: 0.25rem;height: 0.25rem;
                    //                                 border-radius: 50%;
                    //                             }
                    //                             .span1{
                    //                                 margin-right: 0.3rem;
                    //                             }
                    //                         }
                    //                         .p2{
                    //                             font-size:1rem;
                    //                             font-family:AlibabaPuHuiTiM;
                    //                             color:rgba(163,175,187,1);
                    //                             padding-left: 1.75rem;
                    //                         }
                    //                     }
                    //                 }
                    //             }
                    //             .right{
                    //                 // flex: 1;
                    //                 width: 13rem;
                    //                 .p1{
                    //                     margin-top: 1.92rem;
                    //                 }
                    //                 .span1{
                    //                     font-size:3.5rem;
                    //                     font-family:AlibabaPuHuiTiM;
                    //                     color:rgba(255,255,255,1);
                    //                 }
                    //                 .span2{
                    //                     font-size:1rem;
                    //                     font-family:AlibabaPuHuiTiM;
                    //                     color:rgba(255,255,255,1);
                    //                 }
                    //                 .span3{
                    //                     position: relative;
                    //                     top: -0.5rem;
                    //                     font-size:1rem;
                    //                     font-family:AlibabaPuHuiTiR;
                    //                     color:rgba(255,255,255,0.5);
                    //                     letter-spacing:2px;
                    //                 }
                    //             }
                    //         }
                    //         .box2{
                    //             padding-top: 1rem;
                    //             display: flex;
                    //             .box2_left{
                    //                 width: 5.42rem;height: 5.42rem;
                    //                 margin-right: 1.8rem;
                    //                 background: rgba(3,114,186,0.05);
                    //                 display: flex;
                    //                 align-items: center;
                    //                 justify-content: center;
                    //                 img{
                    //                     width: 2rem;
                    //                     height: 2rem;
                    //                 }
                    //             }
                    //             .box2_right{
                    //                 flex: 1;
                    //                 display: flex;
                    //                 flex-wrap: wrap;
                    //                 align-content: flex-start;
                    //                 .title{
                    //                     width: 100%;
                    //                     font-size:1.17rem;
                    //                     font-family:AlibabaPuHuiTiH;
                    //                     color: #2FA5E4;
                    //                     padding-left: 1rem;
                    //                     margin-bottom:0.5rem;
                    //                     display: flex;
                    //                     justify-content: space-between;
                    //                     .span2{
                    //                         i{
                    //                             font-size: 1.2rem;
                    //                         }
                    //                         .text{
                    //                             margin: 0 0.5rem;
                    //                         }
                    //                     }
                    //                 }
                    //                 .li{
                    //                     // max-width: calc(16.66% - 1.5rem);
                    //                     flex: 1;
                    //                     margin-left: 1rem;
                    //                     margin-bottom: 0.6rem;
                    //                     .val{
                    //                         font-size:1rem;
                    //                         font-family:AlibabaPuHuiTiH;
                    //                         color:#333;
                    //                     }
                    //                     .label{
                    //                         position: relative;
                    //                         top: -0.2rem;
                    //                         font-size:1rem;
                    //                         font-family:AlibabaPuHuiTiR;
                    //                         color: #657085;
                    //                     }
                    //                 }
                                    
                    //             }
                    //         }
                    //     }
                    // }
                }
                .right_data_left{
                    margin-top: 1.67rem;
                    height: calc(100% - 32rem);
                    .map{
                        border: 1px solid #EBEFF2;
                        border-radius: 0.83rem;
                        margin-left: 1.67rem;
                        flex: 1;
                        height: 100%;
                        .gm-fullscreen-control{
                            width: 2rem !important;
                            height: 2rem !important;
                        }
                        .gm-bundled-control{  
                            width: 20px !important;
                            margin: 0rem !important;
                            right: 20px !important;
                            bottom: 85px !important;
                            .gmnoprint{
                                // right: 22px !important;
                                >div{
                                    width: 2rem !important;
                                    height: 6rem !important;
                                    >div{
                                        width: auto !important;
                                    }
                                }
                                .gm-control-active{
                                    width: 2rem !important;
                                    height: 3rem !important;
                                    >img{
                                        width: 1rem !important;
                                    }
                                }
                            }
                        }
                        .lamp-control-map-style{
                            width:23.58rem;
                            height:10.5rem;
                            background:rgba(255,255,255,1);
                            box-shadow:-0.33rem 0.33rem 1.17rem 0.17rem rgba(101,112,133,0.21);
                            position: relative;
                            &::after{
                                position: absolute;
                                top: 5rem;
                                left: -5px;
                                content: "";
                                display: block;
                                width: 10px;
                                height: 10px;
                                background: #fff;
                                transform: rotate(45deg);

                            }
                            .div1{
                                display: flex;
                                padding: 1rem 0 0 1rem;
                                .left{
                                    width: 4.3rem;
                                    text-align: center;
                                    img{
                                        max-width: 4.3rem !important;
                                        height: 4.3rem !important;
                                    }
                                }
                                .right{
                                    flex: 1;
                                    margin-left: 1rem;
                                    .p1{
                                        margin-top: 0.5rem;
                                        font-size:1.2rem;
                                        font-family:AlibabaPuHuiTiM;
                                        color:rgba(51,51,51,1);
                                    }
                                    .p2{
                                        font-size:1rem;
                                        font-family:AlibabaPuHuiTiL;
                                        color:rgba(101,112,133,1);
                                        // word-break:break-all;
                                    }
                                }
                            }
                            .div2{
                                margin-top: 1rem;
                                display: flex;
                                border-top: 1px solid rgba(235, 239, 242, 1);
                                padding-top: 0.5rem;
                                .li{
                                    flex: 1;
                                    text-align: center;
                                    .p1{
                                        font-size:1rem;
                                        font-family:AlibabaPuHuiTiR;
                                        color:rgba(51,51,51,1);
                                    }
                                    .p2{
                                        font-size:1rem;
                                        font-family:AlibabaPuHuiTiR;
                                        color:rgba(51,51,51,1);
                                    }
                                }
                            }
                        }
                    }
                    .data_left_t{
                        display: flex;
                        background: #FFFFFF;
                        border: 1px solid #EBEFF2;
                        border-radius: 10px;
                        width: 100%;height: 8.08rem;
                        .div1{
                            flex:1;
                        }
                        .l{
                            margin-top: 1.5rem;
                            width: 0.1rem;
                            height: 5.08rem;
                            background-color: #F0F0F0;
                        }
                        .div2{
                            flex:1;
                            .p1{
                                color: #333333;
                            }
                        }
                        .p1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 2.5rem;
                            color: #05CFAB;
                            text-align: center;
                        }
                        .p2{
                            line-height: 1.2rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            letter-spacing: 0;
                            text-align: center;
                            .img1{
                                margin-right: 0.25rem;
                                height: 1.1rem;
                            }
                            .img2{
                                margin-left: 0.63rem;
                                width: 1rem;
                            }
                        }
                    }
                }
            }
            .dashboard_right_box3{
                .right_top_box3{
                    margin-left: 1.67rem;
                    width: 23rem;height: 28.5rem;
                    overflow: hidden;
                    background: #FFFFFF;
                    border: 1px solid #EBEFF2;
                    border-radius: 0.83rem;
                    >.p1{
                        display: flex;
                        justify-content: space-between;
                        padding: 0 1.5rem;
                        line-height:3rem;
                        margin-top: 2.5rem;
                        .span1{
                            font-size:2.2rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(102,102,102,1);
                        }
                        .span2{
                            font-size:1rem;
                            font-family:PingFangSC-Regular,PingFang SC;
                            font-weight:400;
                            color:rgba(101,112,133,1);
                        }
                        .p1-right{
                            position: relative;
                            .img_box{
                                margin: 0rem 0 0 1.2rem;
                                height: 1.45rem;
                                display: flex;align-items: center;
                                position: absolute;
                                top: -1rem;
                                img{
                                    height: 100%;
                                }
                            }
                        }
                    }
                    .flex_box{
                        margin-top: 1rem;
                        display: flex;
                        padding: 0 1.5rem;
                        >div{
                            text-align: center;
                            flex: 1;
                        }
                        .model{
                            font-size:3rem;
                            font-family:AlibabaPuHuiTiH;
                            color:rgba(51,51,51,1);
                        }
                        .label{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                        }
                    }
                    .flex_box_classification{
                        display: flex;
                        margin: 1rem 1.5rem 2rem;
                        height: 2.5rem;line-height:2.5rem;
                        background:linear-gradient(270deg,rgba(119,123,211,1) 0%,rgba(3,114,186,1) 100%);
                        border-radius:0.5rem;
                        >div{
                            text-align: center;
                            flex: 1;
                        }
                    }
                    // .title{
                    //     margin: 1.2rem 0 0 1.67rem;
                    //     font-size:1.33rem;
                    //     font-family:PingFang-SC-Heavy,PingFang-SC;
                    //     font-weight:800;
                    //     color:rgba(51,51,51,1);
                    // }
                    // .flex_box1{
                    //     display: flex;
                    //     margin-left: 1.67rem;
                    //     .div1{
                    //         margin-right: 0.67rem;
                    //         height: 5.73rem;line-height: 5.73rem;
                    //         font-family: AlibabaPuHuiTiM;
                    //         font-size: 4.17rem;
                    //         color: #333333;
                    //     }
                    //     .div2{
                    //         margin-top: 2rem;
                    //         font-family: AlibabaPuHuiTiM;
                    //         font-size: 1rem;
                    //         .p1{
                    //             color: #333333;
                    //         }
                    //         .p2{
                    //             color: #657085;
                    //         }
                    //     }
                    // }
                    // .flex_box2{
                    //     display: flex;
                    //     justify-content: space-between;
                    //     align-items: center;
                    //     margin:0 1.5rem 0rem;
                    //     padding-left: 0.75rem;
                    //     height: 2.83rem;
                    //     background: rgba(3,114,186,0.05);
                    //     border-radius: 4px;
                    //     .img_box{
                    //         margin: 0rem 0 0 1.2rem;
                    //         height: 1.45rem;
                    //         img{
                    //             height: 100%;
                    //         }
                    //     }
                    //     .text_box{
                    //         font-family: AlibabaPuHuiTiR;
                    //         font-size: 1rem;
                    //         color: #333333;
                    //         letter-spacing: 0;
                    //         margin-right: 1rem;
                    //     }
                    // }
                    .flex_box3{
                        margin: 0 1.5rem 0 2rem;
                        display: flex;
                        justify-content: space-between;
                        // align-items: center;
                        .div1{
                            flex:1.2;
                        }
                        .div2{
                            flex:1;
                        }
                        .div3{
                            flex:1.1;
                        }
                        .p1{
                            margin-top: 1.33rem;
                            // font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                        }
                        .p2{
                            font-family: AlibabaPuHuiTiM;
                            font-size: 1rem;
                            color: #333333;
                        }
                    }
                }
                .right_data_right{
                    height: calc(100% - 32rem);
                    margin-top: 1.67rem;
                    margin-left: 1.67rem;
                    width: 23rem;
                    background-image: linear-gradient(167deg, #F6CDFF 0%, #AD8EFF 88%);
                    border: 1px solid #EBEFF2;
                    border-radius: 10px;
                    .p1{
                        margin-top: 1.83rem;
                        font-family: AlibabaPuHuiTiM;
                        font-size: 1.67rem;
                        color: #FFFFFF;
                        text-align: center;
                        img{
                            height: 1.46rem;
                            margin-right: 0.52rem;
                        }
                    }
                    .progress{
                        margin: 2.5rem auto 0;
                        width: 9.8rem;height: 9.8rem;
                        position: relative;
                        svg{
                            transform:rotate(180deg);
                        }
                        .text1{
                            position: absolute;
                            top: 2.33rem;
                            width: 100%;
                            font-family: AlibabaPuHuiTiH;
                            font-size: 2.67rem;
                            color: #FFFFFF;
                            text-align: center;
                        }
                        .text2{
                            position: absolute;
                            top: 5.1rem;
                            left: 1rem;
                            width: calc(100% - 2rem);
                            font-family: PingFang-SC-Heavy;
                            font-size: 1rem;
                            color: rgba(255,255,255,0.8);
                            text-align: center;
                        }
                    }
                    .box1{
                        margin-top: 1.2rem;
                        display: flex;
                        justify-content: space-between;
                        padding: 0 2rem;
                        .text1{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #FFFFFF;
                            position: relative;
                            i{
                                position: absolute;
                                top: 0.3rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border: 0.21rem solid rgba(255,255,255,0.9);
                                border-radius: 50%;
                            }
                            span{
                                margin-left: 1.75rem;
                                max-width: 14rem;
                                display: inline-block;
                            }
                        }
                        .text2{
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1rem;
                            color: #FFFFFF;
                        }
                    }
                    .box2{
                        margin-top: 0.83rem;
                        display: flex;
                        justify-content: space-between;
                        padding: 0 2rem;
                        .text1{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #FFFFFF;
                            i{
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border: 0.21rem solid rgba(255,255,255,0.3);
                                border-radius: 50%;
                            }
                            span{
                                margin-left: 0.75rem;
                            }
                        }
                        .text2{
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1rem;
                            color: #FFFFFF;
                        }
                    }
                    .btn{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin: 2.08rem 0.92rem 1rem;
                        height: 2.92rem;
                        background: #A14CFC;
                        border-radius: 1.63rem;
                        font-family:AlibabaPuHuiTiM;
                        font-size: 1rem;
                        color: #FFFFFF;
                        padding: 0 1rem 0 1rem;
                        cursor: pointer;
                        line-height: 1rem;
                        .span1{
                            margin-right: 0.2rem;
                            color: #F9B630;
                        }
                        .span2{
                            margin-left: 0.5rem;   
                        }
                        &:hover{
                            .span2{
                                color:rgba(255,255,255,0.8);
                            }
                        }
                        .img_box{
                            font-size: 1rem;
                            color: rgba(255,255,255,0.6);
                        }
                    }
                }
            }
        }
        .full_screen{
            position: fixed;
            top: 4.17rem;
            width: 100%;
            height: calc(100% - 4.17rem);
            background: #fff;
            z-index: 1000;
            .full_screen_map{
                width: 100%;
                height: 100%;

                .gm-fullscreen-control{
                    width: 2rem !important;
                    height: 2rem !important;
                }
                .gm-bundled-control{   
                    width: 20px !important;
                    margin: 0rem !important;
                    right: 20px !important;
                    bottom: 85px !important;
                    .gmnoprint{
                        // right: 22px !important;
                        >div{
                            width: 2rem !important;
                            height: 6rem !important;
                            >div{
                                width: auto !important;
                            }
                        }
                        .gm-control-active{
                            width: 2rem !important;
                            height: 3rem !important;
                            >img{
                                width: 1rem !important;
                            }
                        }
                    }
                }

                .lamp-control-map-style{
                    width:23.58rem;
                    height:10.5rem;
                    background:rgba(255,255,255,1);
                    box-shadow:-0.33rem 0.33rem 1.17rem 0.17rem rgba(101,112,133,0.21);
                    position: relative;
                    &::after{
                        position: absolute;
                        top: 5rem;
                        left: -5px;
                        content: "";
                        display: block;
                        width: 10px;
                        height: 10px;
                        background: #fff;
                        transform: rotate(45deg);

                    }
                    .div1{
                        display: flex;
                        padding: 1rem 0 0 1rem;
                        .left{
                            width: 4.3rem;
                            text-align: center;
                            img{
                                max-width: 4.3rem !important;
                                height: 4.3rem !important;
                            }
                        }
                        .right{
                            flex: 1;
                            margin-left: 1rem;
                            .p1{
                                margin-top: 0.5rem;
                                font-size:1.2rem;
                                font-family:AlibabaPuHuiTiM;
                                color:rgba(51,51,51,1);
                            }
                            .p2{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiL;
                                color:rgba(101,112,133,1);
                                // word-break:break-all;
                            }
                        }
                    }
                    .div2{
                        margin-top: 1rem;
                        display: flex;
                        border-top: 1px solid rgba(235, 239, 242, 1);
                        padding-top: 0.5rem;
                        .li{
                            flex: 1;
                            text-align: center;
                            .p1{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                            }
                            .p2{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                            }
                        }
                    }
                }
            }
            .sideBar_nav{
                position: absolute;
                top: 0;left: 0;
                height: 100%;
                width: 27rem;
                padding: 1.5rem 0 0 1.5rem;
                background: #fff;
                .title_box{
                    margin-bottom: 1.3rem;
                    margin-right: 1.5rem;
                    padding-bottom: 1.5rem;
                    border-bottom: 1px solid #EBEFF2;
                    .box1{
                        display: flex;
                        .left{
                            width: 5.2rem;
                            text-align: center;
                            img{
                                height: 5.2rem;
                                max-width: 5.2rem;
                            }
                        }
                        .right{
                            flex: 1;
                            margin-left: 1rem;
                            .p1{
                                font-size:1.2rem;
                                font-family:AlibabaPuHuiTiM;
                                color:rgba(51,51,51,1);
                            }
                            .p2{
                                margin-top: 0.3rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiL;
                                color:rgba(101,112,133,1);
                                // word-break: break-all;
                            }
                        }
                    }
                    .box2{
                        margin-top: 1rem;
                        display: flex;
                        .li{
                            flex: 1;
                            height:2rem;line-height: 2rem;
                            background:rgba(5,207,171,0.1);
                            border-radius:0.17rem;
                            display: flex;
                            justify-content: space-between;
                            &+.li{
                                margin-left: 0.8rem;
                            }
                            .span1{
                                margin-left: 0.5rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(101,112,133,1);
                            }
                            .span2{
                                margin-right: 0.5rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(5,207,171,1);
                            }
                        }
                    }
                    .box3{
                        margin-top: 0.8rem;
                        height:3.67rem;
                        background:rgba(246,248,250,1);
                        border-radius:0.17rem;
                        display: flex;
                        .li{
                            text-align: center;
                            flex: 1;
                            .p1{
                                margin-top: 0.5rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                            }
                            .p2{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(101,112,133,1);
                            }
                        }
                    }
                }
                .ul_box{
                    height: calc(100% - 14rem);
                    .search{
                        .el-input{
                            margin-left: 1rem;
                            width: 20rem;
                            .el-input__inner{
                                height: 2.5rem;line-height: 2.5rem;
                                border-radius: 1.25rem;
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #333333;
                                border-color: #F0F0F0;
                            }
                            .el-input__icon{
                                height: 2.5rem;line-height: 2.5rem;
                            }
                            .el-icon-search{
                                display: inline-block;
                                top: 0;bottom: 0;
                                right: 0;
                                width: 4rem;
                                background: #05CFAB;
                                border-radius: 1.25rem;
                                cursor: pointer;
                                color: #FFFFFF;
                            }
                            .el-input__suffix{
                                right: 0;
                            }
                        }
                    }
                    .ul{
                        margin-top: 0.5rem;
                        padding-right: 0.5rem;
                        margin-right: 0;
                        height: calc(100% - 5rem);
                        &.scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面轨道*/
                            background: #05CFAB;
                        }
                        .li{
                            display: flex;
                            height:8.42rem;
                            padding: 1.5rem 0.5rem 1.5rem 1.5rem;
                            cursor: pointer;
                            border-bottom: 1px solid #EBEFF2;
                            &:hover{
                                background:rgba(246,248,250,1);

                                .right{
                                    .iconfont{
                                        color: #05CFAB;
                                    }
                                }
                            }
                            &.select{
                                background:rgba(246,248,250,1);

                                .right{
                                    .iconfont{
                                        color: #05CFAB;
                                    }
                                }

                            }
                            .left{
                                width: 5.2rem;
                                text-align: center;
                                img{
                                    height: 5.2rem;
                                    max-width: 5.2rem;
                                }
                            }
                            .right{
                                position: relative;
                                flex: 1;
                                margin-left: 1rem;
                                .p1{
                                    font-size:1.2rem;
                                    font-family:AlibabaPuHuiTiM;
                                    color:rgba(51,51,51,1);
                                }
                                .p2{
                                    margin-top: 0.3rem;
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiL;
                                    color:rgba(101,112,133,1);
                                    // word-break: break-all;
                                }
                                .iconfont{
                                    position: absolute;
                                    top: 0;right: 0rem;
                                    color: #AFBBC6;
                                    background: #fff;
                                }
                            }
                        }
                    }
                }
            }

            .title{
                position: absolute;
                // margin-bottom: 1.3rem;
                // margin-right: 1.5rem;
                padding-bottom: 1.5rem;
                // border-bottom: 1px solid #EBEFF2;
                background: #fff;
                left: 28rem;
                top:0;
                width: 26rem;
                padding: 1.5rem 0.5rem 1.5rem 1.5rem;
                box-shadow:-0.33rem 0.33rem 1.17rem 0.17rem rgba(101,112,133,0.21);
                &::after{
                    position: absolute;
                    top: 6rem;
                    left: -5px;
                    content: "";
                    display: block;
                    width: 10px;
                    height: 10px;
                    background: #fff;
                    transform: rotate(45deg);

                }
                .p_title{
                    font-size:1.2rem;
                    font-family:AlibabaPuHuiTiM;
                    color:rgba(51,51,51,1);
                }
                .box2{
                    margin-top: 1rem;
                    display: flex;
                    .li{
                        &+.li{
                            margin-left: 0.8rem;
                        }
                        flex: 1;
                        height:2rem;line-height: 2rem;
                        background:rgba(5,207,171,0.1);
                        border-radius:0.17rem;
                        display: flex;
                        justify-content: space-between;
                        .span1{
                            margin-left: 0.5rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                        }
                        .span2{
                            margin-right: 0.5rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(5,207,171,1);
                        }
                    }
                }
                .box3{
                    margin-top: 0.8rem;
                    height:3.67rem;
                    // background:rgba(246,248,250,1);
                    border-radius:0.17rem;
                    display: flex;
                    .li{
                        text-align: center;
                        flex: 1;
                        .p1{
                            margin-top: 0.5rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                        }
                    }
                }
            }
        }
    }
</style>
